import { Box, Grid } from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import ActionButton from "../../component/ActionButton";
import SelectField from "../../component/SelectField";
import TypographyLabel from "../../component/Typography";
import { useDispatch } from "react-redux";
import GlobalLoader from "../../component/GlobalLoader";
import { dashboardAction } from "../../store/dashboard/dashboardSlice";
import Toaster from "../../component/Toaster";
import Field from "../../component/Field";

export const POPDone = (props: any) => {
  const { handlePopDoneModalClose, spinner, setSpinner, popInitialValue } =
    props;
  const { t } = useTranslation();

  const dispatch = useDispatch<any>();

  const handleSubmit = (values?: any) => {
    setSpinner(true);
    dispatch(dashboardAction({ apiAction: "updatePopDone", payload: values }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          Toaster.success(undefined, result?.payload?.data?.message);
          handlePopDoneModalClose();
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setSpinner(false);
      });
  };

  return (
    <>
      <div>
        <Formik
          initialValues={popInitialValue}
          enableReinitialize={true}
          onSubmit={handleSubmit}
        >
          {({
            values,
            handleChange,
            handleBlur,
            setFieldValue,
            errors,
            touched,
            dirty,
            isValid,
            handleSubmit,
            handleReset,
            resetForm,
            setValues,
          }: any) => {
            return (
              <Form onSubmit={handleSubmit} onReset={handleReset}>
                <Box className="full" p={1.5}>
                  <Grid
                    container
                    rowSpacing={1}
                    columnSpacing={{ xs: 1, sm: 2 }}
                  >
                    <Grid item xs={12} sm={12} md={12}>
                      <Grid
                        container
                        className="form-ele-gap border-down padding-down-10"
                        columnSpacing={{ xs: 1, sm: 2 }}
                      >
                        <Grid item xs={6} sm={6} md={6}>
                          <TypographyLabel
                            title={t("studentName")}
                            fontWeight={700}
                          />
                        </Grid>
                        <Grid item xs={6} sm={6} md={6}>
                          <TypographyLabel
                            title={t("popDone")}
                            fontWeight={700}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <Field
                        className="textFiled"
                        name="searchBox"
                        placeholder={t("enterHere")}
                        onChange={(e: any) => {
                          const inputValue = e.target.value;
                          const filterdValue = values?.filter((item: any) =>
                            item?.studentName
                              ?.toLowerCase()
                              ?.includes(inputValue?.toLowerCase())
                          );
                          setValues(
                            inputValue?.length > 0
                              ? filterdValue
                              : popInitialValue
                          );
                        }}
                      />
                    </Grid>
                    {values?.map((item: any, index: any) => (
                      <>
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          md={6}
                          className="form-ele-gap"
                        >
                          {values?.[index].studentName}
                        </Grid>
                        <Grid item xs={6} sm={6} md={6}>
                          <SelectField
                            name={`[${index}].popDone`}
                            value={values?.[index].popDone || t("select")}
                            onChange={handleChange}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            options={[
                              { label: "Yes", value: "Yes" },
                              { label: "No", value: "No" },
                            ]}
                            helperText={
                              <ErrorMessage name={`[${index}].popDone`} />
                            }
                            error={
                              touched?.[index]?.popDone &&
                              errors?.[index]?.popDone
                            }
                          />
                        </Grid>
                      </>
                    ))}
                    <Grid item xs={12}>
                      <div className="border-top padding-up-15 center-end flex-gap margin-up-20">
                        <ActionButton
                          type="reset"
                          actionButtonStyle="outline"
                          label={t("clear")}
                        />
                        <ActionButton label={t("submit")} />
                      </div>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            );
          }}
        </Formik>
        <GlobalLoader loading={spinner} />
      </div>
    </>
  );
};
